import { deleteApi, get, post } from "../GenericServices";

const RiskOpportunities = {
  riskList: (projectId) => {
    return get(`risk-opportunities`, { projectId: projectId, type: "RISK" });
  },
  opportunityList: (projectId) => {
    return get(`risk-opportunities`, { projectId: projectId, type: "OPPORTUNITY" });
  },
  riskDetail: (projectId, id) => {
    return get(`risk-opportunities`, { id: id, projectId: projectId, type: "RISK" });
  },
  opportunityDetail: (projectId, id) => {
    return get(`risk-opportunities`, { id: id, projectId: projectId, type: "OPPORTUNITY" });
  },
  save: (data) => {
    return post(`risk-opportunities`, data);
  },
  delete: (id) => {
    return deleteApi(`risk-opportunities/${id}`);
  },
};

export default RiskOpportunities;
